import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

export class CodigoDeCupo {
  static async getDetalleCodigoDeCupo (codigoDeCupo) {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_codigo_de_cupo_por_codigo?r={"clave":{"codigo_cupo": "${codigoDeCupo.toUpperCase()}"}}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data[0])
  }

  static async getCodigoDeCupoTotalCereal () {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_codigo_de_cupo_total_cereal`)
      .then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static async getCodigosDeCupo (fechaDesde, fechaHasta) {
    const axios = getAxiosInstance()
    const orden = '"orden":["fecha_cupo"]'
    const filtro = `{"clave": {"fecha_desde": "${fechaDesde}", "fecha_hasta": "${fechaHasta}"}, ${orden}}`
    return axios.get(`/consulta_codigos_de_cupo?r=${filtro}`)
      .then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }

  static async getDataTablaConsultaCodigoDeCupos (fechaActualizada) {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_codigo_de_cupo?r={"clave":{"fecha_cupo": "${fechaActualizada}"}}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static async getDataTablaConsultaCodigoDeCuposFiltrada (fechaDesde, fechaHasta, cereal, arribo) {
    const axios = getAxiosInstance()
    const clave = {
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta,
      cereal,
      arribo
    }
    return axios.get('/consulta_codigo_de_cupo_filtrada?r={"clave":' + JSON.stringify(clave) + ', "orden":["d:fecha_cupo"]}')
      .then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }
}
